import apiSlice from 'app/apiSlice';

const inventoryApi = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getInventoryOrders: builder.query({
      query: () => ({
        url: `inventory/orders`,
      }),
      transformResponse: response => {
        return response.data;
      },
    }),

    getInventoryBalances: builder.query({
      query: () => ({
        url: `inventory/balances`,
      }),
      transformResponse: response => {
        return response.data;
      },
    }),
  }),
  overrideExisting: false, // Avoid overwriting existing endpoints
});

export const { useGetInventoryOrdersQuery, useGetInventoryBalancesQuery } =
  inventoryApi;

export default inventoryApi;
